import { useTranslation } from 'react-i18next';

import {
  CatalogueListbox,
  CatalogueListboxProps,
} from '@/components/CatalogueListbox/CatalogueListbox';
import {
  activeOptionsStaleTime,
  rangeParams,
  TRangeActiveOptions,
} from '@/features/mentions/components/MentionFilters/active-options/active-options';

import { usePeoplePicker } from '../hooks/use-people-picker';

type PeopleCatalogueListboxProps = CatalogueListboxProps & {
  /** Narrows the listed people to those present in the list's range. */
  activeOptions?: TRangeActiveOptions;
  /** Names a selected person who can no longer be resolved, so they stay visible and counted. */
  unresolvedLabel?: string;
};

export function PeopleCatalogueListbox({
  activeOptions,
  unresolvedLabel,
  ...listbox
}: PeopleCatalogueListboxProps) {
  const { t } = useTranslation();
  const picker = usePeoplePicker({
    value: listbox.mode === 'multiple' ? listbox.value : null,
    fallbackLabel: unresolvedLabel,
    range: activeOptions && rangeParams(activeOptions),
    staleTime: activeOptions && activeOptionsStaleTime(activeOptions.source),
    openOnMount: true,
  });

  return (
    <CatalogueListbox
      {...listbox}
      picker={picker}
      loadingMoreLabel={t('Cargando más personas...')}
      footerTestId="people-filter-footer"
    />
  );
}
